// extracted by mini-css-extract-plugin
module.exports = {"details_header":"BookingRightPanel_details_header__1Sxqj","header_above_list":"BookingRightPanel_header_above_list__3enR4"};